import { Link } from 'react-router';
import { api } from '../api.js';
import { ErrorNotice, Loading } from '../components/Notice.js';
import { StatusPill, TypeBadge } from '../components/StatusPill.js';
import { useResource } from '../hooks.js';

export function AppsPage() {
  const apps = useResource(() => api.listApps(), []);

  return (
    <>
      <div className="page-head">
        <h1>Your apps</h1>
        <Link to="/new" className="btn btn-primary">
          New app
        </Link>
      </div>
      <ErrorNotice error={apps.error} />
      {apps.loading && !apps.data ? <Loading what="Loading your apps" /> : null}
      {apps.data && apps.data.apps.length === 0 ? (
        <div className="card empty">
          <h2>No apps yet</h2>
          <p>
            This is where you put an app you built with an AI coding tool online, behind Sign in with Xero, so
            only the people you invite can open it.
          </p>
          <p>
            Create an app, upload a zip of your project, then add the email addresses of the people who need
            it.
          </p>
          <Link to="/new" className="btn btn-primary">
            Create your first app
          </Link>
        </div>
      ) : null}
      {apps.data && apps.data.apps.length > 0 ? (
        <ul className="card-grid app-list">
          {apps.data.apps.map((app) => (
            <li key={app.slug}>
              <Link to={`/apps/${encodeURIComponent(app.slug)}`} className="card app-card">
                <span className="name">{app.name}</span>
                <span className="mono small subtle">{app.slug}</span>
                <span className="meta">
                  <TypeBadge type={app.type} />
                  <StatusPill status={app.status} />
                </span>
                <span className="host">{app.host}</span>
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
}
